import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import MessageModalStore from "@/stores/MessageModalStore";

const MessageDialog = () => {
  const isOpen = MessageModalStore((state) => state.isOpen);
  const message = MessageModalStore((state) => state.message);
  const callback = MessageModalStore((state) => state.callback);

  return (
    <Dialog open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle />
          <div className="mt-2">
            <p className="whitespace-pre-line text-center">{message}</p>
          </div>
        </DialogHeader>

        <DialogFooter className="mt-6">
          <Button onClick={() => callback()}>확인</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MessageDialog;
